'use client'
import Link from 'next/link'
import BannerLandingPage from './banner'
import { Button, buttonVariants } from '@/components/ui/button'
import Image from 'next/image'
import { Navbar } from './navbar'
import { Suspense, useState } from 'react'
import { Sidebar } from './sidebar'

export const HeroPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev)
  }
  const closeSidebarOnly = () => {
    setIsSidebarOpen(false)
  }
  return (
    <>
      <Sidebar isSideBarOpen={isSidebarOpen} closeSidebar={toggleSidebar} closeSidebarOnly={closeSidebarOnly} />
      <div className="relative overflow-hidden" data-aos="fade">
        <Suspense>
          <Navbar isTransparent toggleSidebar={toggleSidebar} />
        </Suspense>
        <div className="relative">
          <BannerLandingPage url="https://cdn.lykstage.com/videos/bg-video.mp4" />
          <Image
            src="/landing-page/gradient-effect.png"
            alt="gradient effect image"
            fill
            sizes="100vw"
            style={{ objectFit: 'cover', objectPosition: 'center' }}
            priority
          />
        </div>
        <div className="absolute inset-0 z-10 mx-auto mt-[220px] flex max-w-[854px] flex-col px-2 text-center text-white md:mt-[250px] md:px-4 ">
          <h2
            className="mb-4 text-2xl font-bold sm:text-3xl md:mb-10 md:text-4xl"
          // data-aos="fade-up"
          // data-aos-anchor-placement="top-bottom"
          >
            {/* Discover and create amazing content. Get&nbsp;
            <span className="text-primary-green">rewarded</span> for your watch
            time. */}
            LYKSTAGE is a user-generated video platform where watch time turns into shared value.
          </h2>
          <p
            className="mb-4 px-2 text-sm font-semibold xs:leading-6 sm:text-lg md:px-6"
          // data-aos="fade-up"
          // data-aos-anchor-placement="top-bottom"
          >
            {/* Video Sharing Platform that serves not only video content creators but also the viewers. */}
            Logged-in viewers earn LYK Coins only when they actively watch ad-enabled videos for at least 30 uninterrupted seconds without skipping. Creators earn revenue from actual ad impressions on uploaded content, with earnings varying by content traction and ad engagement.
          </p>
          <div
            className="mt-4 flex items-center justify-center"
            data-aos="fade-up"
            data-aos-anchor-placement="top-bottom"
          >
            <Button asChild style={{ borderRadius: '4px' }}>
              <Link
                href="/home"
                className={buttonVariants({
                  variant: 'primaryGreen',
                })}
              >
                Start Watching
              </Link>
            </Button>
            <Link
              className="ml-5 cursor-pointer transition-all duration-300 hover:text-primary-green hover:underline"
              data-aos="fade-up"
              href="#learn-more"
              data-aos-anchor-placement="top-bottom"
            >
              Learn more
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
